import PropTypes from 'prop-types';
import React from 'react';
import Display from '@loggi/ui/components/display';
import ViewContainer from '@loggi/ui/components/view-container';
import Col from '@loggi/ui/components/col';
import View from '@loggi/ui/components/view';
import classNames from 'classnames';
import styles from '../index.scss';
import { STATUS, STATUS_LIST } from '@loggi/ui/components/utils/colors/status';

function InputStatus({ text, info, status, disabled }) {
  const classesInputStatus = classNames(
    styles.statusText,
    { [styles.statusTextError]: !disabled && status === STATUS.ERROR },
    { [styles.statusTextWarning]: !disabled && status === STATUS.WARNING }
  );
  return (
    <Display when={Boolean(!disabled && (text || info))}>
      {() => (
        <ViewContainer fluid>
          <Col size={6}>{info}</Col>
          <Col size={6}>
            <View className={classesInputStatus}>{text}</View>
          </Col>
        </ViewContainer>
      )}
    </Display>
  );
}

InputStatus.defaultProps = {
  disabled: false
};

InputStatus.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  status: PropTypes.oneOf(STATUS_LIST),
  info: PropTypes.element
};

InputStatus.displayName = 'InputStatus';

export default InputStatus;
